export default "__VITE_ASSET__f42f019e__"